// Actions related to SSE
import { serverURL } from "../constants/constants";
import axios from "axios";

import { errorResponse } from "../actions";

export function fetchTerminate() {
  return function (dispatch) {
    // console.log("GET request made for /terminate");
    return axios.get(serverURL + "/terminate").then(
      (response) => {},
      (error) => dispatch(errorResponse(error))
    );
  };
}
